import { images } from "../../assets/images";
import DashboardWidget from "../../components/common/DashboardWidget/DashboardWidget";
import { useDispatch, useSelector } from "react-redux";
import { getOrganizerCurrency } from "../../utils/currency";
import { fetchOrganizersThunk } from "../../store/organizer/thunks";
import { RootState } from "../../store/rootReducer";
import { AppDispatch } from "../../store/store";
import React, { useState, useEffect } from "react";
import { getReport ,getEventBySlug } from "../../api";
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
type Props = {};
const UserEventHomePage = (props: Props) => {
  const currencySymbol = getOrganizerCurrency().symbol;
  const [urlModalOpen, setUrlModalOpen] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [reportList, setReportList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [venueName, setVenueName] = useState("");
  const dispatch: AppDispatch = useDispatch();
  const [dashboardData, setDashboardData] = useState({
    totalBookings: 0,
    totalRevenue: 0,
    totalTickets: 0,
    totalAttendees: 0,
    totalTicketsSold: 0,
    totalDiscount: 0
  });
  const [eventInfo, setEventInfo] = useState<{ eventName: string; thumbImg: string }>({
  eventName: "",
  thumbImg: "", 
});
  useEffect(() => {
    dispatch(fetchOrganizersThunk());
  }, [dispatch]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
         const userData = localStorage.getItem("userData");
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        const venue = parsedUserData?.venueName || parsedUserData?.venue?.venueName || "";
        setVenueName(venue);
      }
        const eventData = localStorage.getItem("eventData");
        console.log("eventData", eventData);
        if (eventData) {
          const eventSlug = JSON.parse(eventData).eventId;
          const slugId = JSON.parse(eventData).slugId;
          const eventDetailsArr = await getEventBySlug(slugId);
          const eventDetails = eventDetailsArr?.[0];
          const { ticketFee, processingFee } = JSON.parse(eventData);
          let summaryData: any[] = [];
          let totalEventoxFee = 0;
          let totalStripeFee = 0;
          let totalTicketAmount = 0;
          let totalDiscountAmount = 0;
          let totalTicketSold = 0;
          let totalGrandTotal = 0;
          let totalSuccessBooking = 0;
          let totalOrganizerRevenue = 0;
          // if processingFee and ticketFee is 0 then fee collected from organizer else fee collected from user
          const feeCollectedFromOrganizer = processingFee === 0 && ticketFee === 0;


          setEventInfo({
                        eventName: eventDetails?.eventName || "Unnamed Event",
                        thumbImg: eventDetails?.thumbImg || images.defaultProfileIcon,
                      });
          const response = await getReport(eventSlug);
          const venueId = localStorage.getItem("venueId");
          const data = response.filter((item:any) => item.bookingStatus === 'confirmed');
            data.forEach((item:any) => {
              if (item.bookedBy === '0' && item.venueId === venueId) {
        
                let stripefee = 0;
                let eventoxRevenue = 0;
                let organizerRevenue = 0;
        
                const grandTotal = item.grandTotal;
                const ticketAmount = item.totalTicketAmount;
                const discountAmount = item.discountAmount ? item.discountAmount : 0;
                const ticketCount = item.totalTicketCount;
                if (feeCollectedFromOrganizer) {
                  stripefee = ((grandTotal / 100) * 2.7) + 0.30;
                  const ticketFee = ticketCount * 0.5;
                  const ourFee = ((grandTotal / 100) * 2.5) + (ticketFee);
                  if (Number(ticketCount) === 1) {
                    eventoxRevenue = 0;
                  } else {
                    eventoxRevenue = Number(ourFee) - Number(stripefee);
                  }
        
                  organizerRevenue = grandTotal - stripefee - eventoxRevenue - discountAmount;
        
                } else {
                  if (item.stripeRevenue === null) {
                    stripefee = ((grandTotal / 100) * 2.7) + 0.30;
                  } else {
                    stripefee = item.stripeRevenue;
                  }
                  if (item.eventoxRevenue === null) {
                    eventoxRevenue = grandTotal - stripefee - ticketAmount;
                  } else {
                    eventoxRevenue = item.eventoxRevenue;
                  }
                  if (item.organizerRevenue === null) {
                    organizerRevenue = (ticketAmount - stripefee - eventoxRevenue - discountAmount);
                  } else {
                    organizerRevenue = item.organizerRevenue;
                  }
                }
        
                totalStripeFee += Number(stripefee);
                totalEventoxFee += Number(eventoxRevenue);
                totalTicketAmount += Number(ticketAmount);
                totalDiscountAmount += Number(discountAmount);
                totalTicketSold += Number(item?.totalTicketCount);
                totalGrandTotal += Number(grandTotal);
                totalOrganizerRevenue += Number(organizerRevenue);
                totalSuccessBooking += 1;
        
                const totalFee = Number(stripefee||0) + Number(eventoxRevenue||0);
                
              }
            })
           
            setDashboardData({
              totalBookings:totalSuccessBooking,
              totalRevenue:totalOrganizerRevenue,
              totalTickets:totalTicketSold,
              totalAttendees:0,
              totalTicketsSold:totalTicketSold,
              totalDiscount:totalDiscountAmount
            });
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
  const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(selectedUrl);
        toast.success("Copied to clipboard!");
        setUrlModalOpen(false);
      } catch {
        toast.error("Copy failed");
      }
    };

    const handleNavigate = () => {
      window.open(selectedUrl, "_blank");
      setUrlModalOpen(false);
    };
  // const totalBookings = reportList.length;
  // const totalRevenue = reportList.reduce((sum, item) => sum + (item.totalTicketAmount || 0), 0);
  // const totalTickets = reportList.reduce((sum, item) => sum + (item.totalTicketCount || 0), 0);

  // const totalAttendees = 0

  return (
    <div className="row">
      <div className="col-12">
        <ToastContainer
        autoClose={1500}
        />
        <div className="d-main-title">
          <h3>
            <i className="fa-solid fa-gauge me-3"></i>Dashboard
          </h3>
        </div>
        <div className="col-md-12">
<div className="main-card add-organisation-card p-4 mt-5 d-flex flex-column ">
            <div className="ocard-left">
              <div className="ocard-avatar">
                <img src={eventInfo.thumbImg} alt="" />
              </div>
              <div className="ocard-name">
                <h4>{eventInfo.eventName}</h4>
              </div>
            </div>
             <div className="ocard-name mt-2">
                <h6>Venue :{venueName}</h6>
              </div>
           <div className="event-btn-group position-center">
              <button
                className="esv-btn me-2"
                onClick={() => {
                  const eventData = localStorage.getItem("eventData");
                  if (eventData) {
                    const { slugId } = JSON.parse(eventData);
                    setSelectedUrl(`https://eventox.co/event/${slugId}`);
                    setSelectedLabel("Full URL");
                    setUrlModalOpen(true);
                  }
                }}
              >
                <i className="fa-solid fa-link me-2"></i>Url
              </button>
              <button
                className="esv-btn me-2"
                onClick={() => {
                  const eventData = localStorage.getItem("eventData");
                  if (eventData) {
                    const { tinyUrl } = JSON.parse(eventData);
                    setSelectedUrl(`https://eventox.co/tiny/${tinyUrl}`);
                    setSelectedLabel("Tiny URL");
                    setUrlModalOpen(true);
                  }
                }}
              >
                <i className="fa-solid fa-link me-2"></i>Tiny url
              </button>
            </div>
          </div>
          <div className="main-card mt-2">
            <div className="dashboard-wrap-content">
              <div className="dashboard-report-content mt-4">
                <div className="row">
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <Link to="/venue-event/reports/attendee-report" >
                    <DashboardWidget
                      mainTitle="Total Tickets"
                      subTitle={dashboardData.totalBookings.toString()}
                      cardClass="purple"
                      icon="fa-calendar-days"
                    />
                    </Link>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <Link to="/venue-event/reports/event-revenue-report" >
                    <DashboardWidget
                      mainTitle="Total Revenue"
                      subTitle={`${currencySymbol} ${dashboardData.totalRevenue.toFixed(2)}`}
                      cardClass="red"
                      icon="fa-credit-card"
                    />
                    </Link>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <Link to="/venue-event/reports/ticket-report" >
                    <DashboardWidget
                      mainTitle="Total Attendees"
                      subTitle={dashboardData.totalTicketsSold.toString()}
                      cardClass="info"
                      icon="fa-ticket"
                    />
                    </Link>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <Link to="/venue-event/reports/booking-status-report" >
                    <DashboardWidget
                      mainTitle="Total Discount"
                      subTitle={`${currencySymbol} ${dashboardData.totalDiscount.toFixed(2)}`}
                      cardClass="success"
                      icon="fa-user"
                    />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal centered isOpen={urlModalOpen} toggle={() => setUrlModalOpen(false)}>
            <ModalHeader toggle={() => setUrlModalOpen(false)}>{selectedLabel}</ModalHeader>
            <ModalBody className="text-center  text-danger">
              What would you like to do with this link?
              <div className=" mt-2 text-break text-primary" >{selectedUrl}</div>
            </ModalBody>
            <ModalFooter className="justify-content-center">
              <Button color="danger" onClick={handleNavigate}>Open in New Tab</Button>
              <Button color="danger " onClick={handleCopy}>
               <i className="fa-solid fa-share-nodes me-2 "></i>
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div> 
    </div>
  );
};

export default UserEventHomePage;
